// Mirrored in applications/platform-app/components/web-analytics — change both.
import React from 'react';
import type { WebFilter } from './types';
import { filterLabel } from './format';

/** Active filter chips — × removes one. */
export const FilterChips: React.FC<{ filters: WebFilter[]; onRemove: (f: WebFilter) => void; onClear?: () => void }> = ({ filters, onRemove, onClear }) => {
  if (!filters.length) return null;
  return (
    <>
      {filters.map((f) => (
        <span key={`${f.dim}:${f.value}`} data-testid="wa-chip" className="inline-flex items-center gap-1.5 rounded-full pl-3 pr-1 h-8 text-xs font-semibold max-w-[320px]" style={{ background: '#FFF1F3', color: '#9F1239', border: '1px solid #fecdd3' }}>
          <span className="truncate">{filterLabel(f)}</span>
          {/* 22px visual dot inside a 44px hit area */}
          <button
            type="button" aria-label={`Remove filter ${filterLabel(f)}`} onClick={() => onRemove(f)}
            className="relative w-[22px] h-[22px] rounded-full border-0 text-[13px] leading-none shrink-0 before:content-[''] before:absolute before:-inset-[11px]"
            style={{ background: '#fecdd3', color: '#9F1239' }}
          >
            ×
          </button>
        </span>
      ))}
      {filters.length > 1 && onClear && (
        <button type="button" onClick={onClear} className="text-xs font-semibold min-h-[44px] px-2 bg-transparent border-0 text-stone-500 hover:text-stone-900">Clear all</button>
      )}
    </>
  );
};
